import { makeActionCreator } from '../../../utilities'
import { DriversLicenseScannerConstants } from './driversLicenseScanner.constants'

export const loadWasm = makeActionCreator(DriversLicenseScannerConstants.LOAD_WASM)
export const appendMessage = makeActionCreator(DriversLicenseScannerConstants.APPEND_MESSAGE, 'message')
export const setLibLoaded = makeActionCreator(DriversLicenseScannerConstants.SET_LIB_LOADED, 'libLoaded')
export const setResultValue = makeActionCreator(DriversLicenseScannerConstants.SET_RESULT_VALUE, 'resultValue')
export const setResultItems = makeActionCreator(DriversLicenseScannerConstants.SET_RESULT_ITEMS, 'resultItems')
export const setShowScanner = makeActionCreator(DriversLicenseScannerConstants.SET_SHOW_SCANNER, 'showScanner')
export const setLicenseInfo = makeActionCreator(DriversLicenseScannerConstants.SET_LICENSE_INFO, 'licenseInfo')
export const toggleAllDriversLicenseKeys = makeActionCreator(
  DriversLicenseScannerConstants.TOGGLE_ALL_DRIVERS_LICENSE_KEYS
)
export const toggleDriversLicenseKey = makeActionCreator(
  DriversLicenseScannerConstants.TOGGLE_DRIVERS_LICENSE_KEY,
  'licenseKey'
)
export const setDriversLicenseKeys = makeActionCreator(
  DriversLicenseScannerConstants.SET_DRIVERS_LICENSE_KEYS,
  'licenseKeys'
)
export const importDriversLicenseInfo = makeActionCreator(DriversLicenseScannerConstants.IMPORT_DRIVERS_LICENSE_INFO)
